"use client";

import * as React from "react";
import cx from "clsx";
import handleKeyDown from "../../../utils/handleKeyDown";
import ChevronForward from "../../../icons/ChevronForward";
const ItinerarySegmentBanner = ({
  onClick,
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cx("px-md box-border flex w-full items-center justify-between overflow-hidden py-0", onClick ? "cursor-pointer" : "cursor-default", "[&_.orbit-itinerary-badge-list]:!ms-0", "[&_.orbit-separator]:-ml-md [&_.orbit-separator]:!w-[150%]", "[&_>_div]:max-w-[calc(100%-20px)]"),
    role: "button",
    tabIndex: onClick ? 0 : -1,
    onKeyDown: handleKeyDown(onClick),
    onClick: ev => {
      ev.stopPropagation();
      if (onClick) onClick(ev);
    }
  }, /*#__PURE__*/React.createElement("div", null, children), onClick && /*#__PURE__*/React.createElement(ChevronForward, {
    color: "secondary"
  }));
};
export default ItinerarySegmentBanner;